import { useAuth } from 'context/auth.context';

export default function HomeRoute() {
  const { actor } = useAuth();

  const greeting = () => {
    const hour = new Date().getHours();
    if (hour >= 6 && hour < 12) {
      return 'Buenos días';
    }
    if (hour >= 12 && hour < 20) {
      return 'Buenas tardes';
    }
    return 'Buenas noches';
  };

  return (
    <div>
      <div className="Box rounded-top-0">
        <div className="blankslate">
          <div className="h1 d-flex flex-justify-center pb-2">👋</div>
          <h1 className="h2 blankslate-heading">
            {greeting()}, {actor.firstName}
          </h1>
          <p>
            Bienvenido a tu cuenta. Aquí podrás ver las últimas actualizaciones
            de tus visitas, ver las propiedades, y mucho más. ¡Esperamos que te
            guste!
          </p>
        </div>
      </div>
    </div>
  );
}
